<div class="modal-header">
  <div>
    <h5 class="modal-title">
      Generate widget customization with AI
    </h5>
  </div>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="generate()">
    <div class="form-group">
      <label class="d-block">Generation mode</label>
      <div class="custom-control custom-radio custom-control-inline">
        <input id="widget-ai-fresh" class="custom-control-input" type="radio"
               value="fresh" formControlName="mode">
        <label class="custom-control-label" for="widget-ai-fresh">Create fresh code</label>
      </div>
      <div class="custom-control custom-radio custom-control-inline">
        <input id="widget-ai-modify" class="custom-control-input" type="radio"
               value="modify" formControlName="mode">
        <label class="custom-control-label" for="widget-ai-modify">Modify current code</label>
      </div>
    </div>

    <div class="form-group">
      <label for="widget-ai-prompt">
        {{ isLegacyConversion ? 'Optional conversion guidance' : 'Describe the customization' }}
      </label>
      <textarea id="widget-ai-prompt" class="form-control" rows="4" maxlength="4000"
                formControlName="prompt"
                placeholder="Describe the desired widget behavior and appearance"></textarea>
      <small class="text-danger"
             *ngIf="form.get('prompt').touched && form.get('prompt').hasError('required')">
        A prompt is required.
      </small>
      <small class="form-text text-muted text-right">
        {{ form.get('prompt').value?.length || 0 }}/4000
      </small>
    </div>

    <div class="alert alert-danger d-flex align-items-start" role="alert"
         aria-live="assertive" *ngIf="error">
      <i class="fa fa-exclamation-circle mt-1 mr-2" aria-hidden="true"></i>
      <div>
        <strong>
          {{ result ? 'A new customization wasn’t generated.' : 'Customization wasn’t generated.' }}
        </strong>
        <div>{{ error }}</div>
      </div>
    </div>

    <div class="d-flex flex-wrap align-items-center">
      <button type="submit" class="btn btn-primary" [disabled]="loading">
        <i class="fa fa-spinner fa-spin mr-1" *ngIf="loading"></i>
        {{ loading ? 'Generating…' : (result ? 'Generate again' : 'Generate') }}
      </button>
      <button type="button" class="btn btn-outline-primary ml-2"
              *ngIf="hasLegacyCustomization"
              [disabled]="loading"
              (click)="convertLegacy()">
        Convert legacy customization with AI
      </button>
    </div>
  </form>

  <div class="widget-ai-result mt-4" *ngIf="result" aria-live="polite">
    <div class="widget-ai-summary mb-3" *ngIf="result.summary">
      <h6>
        <i class="fa fa-info-circle mr-1" aria-hidden="true"></i>
        Summary
      </h6>
      <p>{{result.summary}}</p>
    </div>

    <div class="widget-ai-warnings mb-3" role="alert" *ngIf="result.warnings?.length">
      <h6>
        <i class="fa fa-exclamation-triangle mr-1" aria-hidden="true"></i>
        Warnings
      </h6>
      <ul>
        <li *ngFor="let warning of result.warnings">{{warning}}</li>
      </ul>
    </div>

    <div class="form-group">
      <label>Generated JavaScript</label>
      <ace-editor style="min-height: 260px;" [mode]="'javascript'"
                  [options]="aceEditorOptions" [(text)]="result.custom_script"></ace-editor>
    </div>

    <div class="form-group mb-0">
      <label>Generated CSS</label>
      <ace-editor style="min-height: 260px;" [mode]="'css'"
                  [options]="aceEditorOptions" [(text)]="result.custom_css"></ace-editor>
    </div>
  </div>
</div>

<div class="modal-footer">
  <small class="text-muted mr-auto" *ngIf="result">
    Apply updates the editors only. Use Save on the widget settings page to persist changes.
  </small>
  <button type="button" class="btn btn-default" (click)="activeModal.dismiss()">Cancel</button>
  <button type="button" class="btn btn-primary" [disabled]="!result" (click)="apply()">
    Apply to editors
  </button>
</div>
